<template>
  <div>
    <img src="@/assets/ecopoliza.jpg" style="width:100%" />
    <h2>En MMT Seguros nos comprometemos con el medio ambiente</h2>
    <p>
      Por eso estamos cambiando nuestra infraestructura para evitar gastar papel
      innecesariamente.
    </p>
    <p>
      Si quieres que a partir de ahora te envíemos cualquier tipo de
      comunicación por e-mail en vez de por correo ordinario, pulsa en el
      siguiente enlace:
      <a href="#" class="link" @click.prevent="email()"
        >Sí, enviadme cualquier comunicación por e-email
      </a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    email() {},
  },
};
</script>

<style lang="scss" scoped>
.link {
  color: $colorMMT;
  font-weight: 460;
}
</style>
